import { Outlet, RouteObject } from "react-router-dom";
import featureEnabled from "../lib/featureEnabled";
import MenuLayout from "../MenuLayout";
import SessionBoundary from "../SessionBoundary";
import ValidateUUID from "../ValidateUUID";
import AddContactsScreen from "./AddContactsScreen";
import ContactDetailsScreen from "./ContactDetailsScreen";
import ContactsScreen from "./ContactsScreen";
import ReviewAndResubmitPage from "./ReviewAndResubmitPage";

const ContactsRoutes: RouteObject = {
  path: "/contacts",
  element: (
    <SessionBoundary>
      <Outlet />
    </SessionBoundary>
  ),
  children: [
    {
      index: true,
      element: (
        <MenuLayout currentTab="contacts">
          <ContactsScreen />
        </MenuLayout>
      ),
    },
    {
      path: ":connectionId",
      element: (
        <MenuLayout currentTab="contacts">
          <ValidateUUID id="connectionId">
            <ContactDetailsScreen />
          </ValidateUUID>
        </MenuLayout>
      ),
    },
    ...(featureEnabled("CONTACT_RESUBMIT_NEW_UX")
      ? [
          {
            path: ":connectionId/resubmit",
            element: (
              <MenuLayout currentTab="contacts">
                <ValidateUUID id="connectionId">
                  <ReviewAndResubmitPage />
                </ValidateUUID>
              </MenuLayout>
            ),
          },
        ]
      : []),
    { path: "add", element: <AddContactsScreen /> },
  ],
};

export default ContactsRoutes;
